module.exports = __webpack_public_path__ + "static/media/jeremy-alford-68_PLKkF_ww-unsplash.f321144e.jpg";